import { render } from "./LockScreen.vue?vue&type=template&id=07f290d8"
import script from "./LockScreen.vue?vue&type=script&lang=js"
export * from "./LockScreen.vue?vue&type=script&lang=js"
script.render = render

export default script